import React from 'react';
import styled, { css } from 'styled-components';

import { Container } from 'ui/components/styled';
import { Icon } from 'ui/components/shared';

export const Avatar = ({ children, src, alt, ...rest }) => {
  return (
    <AvatarContainer title={children} {...rest}>
      <Icon src={src} alt={alt} size="20px" mr="xs" />
      <span>{children}</span>
    </AvatarContainer>
  );
};

const AvatarContainer = styled(Container)`
  flex-direction: row;
  align-items: center;
  font-weight: normal;
  font-size: 14px;
  letter-spacing: 0.04em;
  text-align: left;
  color: #888;
  width: ${({ width = 'auto' }) => width};
  height: auto;
  ${({ textOverflow = 'ellipsis' }) =>
    textOverflow === 'ellipsis' &&
    css`
      overflow: hidden;

      > span {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    `}
`;
